module.exports = __webpack_public_path__ + "static/media/missionvision.4eb09969.png";